'use client'

import { useEffect, useState } from 'react'

import { generateTraceId, toReferenceCode } from '@repo/observability'
import { clientLogger } from '@repo/observability/client'
import { AppFallback } from '@repo/observability/react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const [traceId] = useState(() => generateTraceId())

  useEffect(() => {
    void clientLogger.error(error, {
      traceId,
      severity: 'critical',
      handled: false,
      userImpact: 'blocked',
      componentName: 'GlobalError',
      action: 'reactRootBoundary',
      metadata: { digest: error.digest },
    })
  }, [error, traceId])

  return (
    <html>
      <body>
        <AppFallback
          referenceCode={toReferenceCode(traceId)}
          onRetry={reset}
          supportEmail="support@alli.io"
        />
      </body>
    </html>
  )
}
